window.addEventListener('DOMContentLoaded', ()=> {

    (function modificarSKU() {
        let sku_by_size;
        const content_sizes = document.querySelectorAll('.container-item-talla');

        if (content_sizes) {
            content_sizes.forEach((container) => {
                const input = container.querySelector('input'); // Encuentra el input dentro del contenedor

                if (input && !input.disabled) {
                    input.addEventListener('click', () => {
                        const sku_element = document.querySelector('.variant-sku');
                        sku_by_size = container.dataset.sku; // Obtiene el SKU del contenedor
                        console.log('SKU:', sku_by_size);

                        if (sku_element) {
                            sku_element.innerHTML = `<span>SKU:</span> ${sku_by_size}`;
                        } else {
                            console.warn('Elemento .variant-sku no encontrado.');
                        }
                    });
                }
            });
        } else {
            console.warn('No se encontraron elementos .container-item-talla.');
        }
    })();

    
    // (function validarClickEnTallas() {

    //     const jbtz_url = window.location.href;

    //     const addToCartBtn = document.querySelector('[id^="ProductSubmitButton-"]');
    //     let inputTalla = document.getElementsByClassName('input-size-validator');
    //     let addToCartBtnText = document.querySelector('[id^="ProductSubmitButton-"] span');

    //     // Valida que solo se le aplique a productos con tallas: 
    //     if(!/jibbitz/i.test(jbtz_url)) {
    //       console.log('Tiene JBTZ');
    //       if(addToCartBtn){
    //         addToCartBtn.disabled = true; // Deshabilite el botón
    //         addToCartBtnText.textContent = 'Selecciona una talla';
    //       }
  
    //       for(let i=0; i < inputTalla.length; i++) {             
    //         inputTalla[i].addEventListener('click', () => {    
    //           addToCartBtn.disabled = false; //Habilitar el botón
    //           addToCartBtnText.textContent = 'Agregar al carrito';            
    //         });  
    //       }  
    //     }
    
    //   })();

    (function validarClickEnTallas() {

      const jbtz_url = window.location.href;

      const addToCartBtn = document.querySelector('[id^="ProductSubmitButton-"]');
      let inputTalla = document.getElementsByClassName('input-size-validator');
      let addToCartBtnText = document.querySelector('[id^="ProductSubmitButton-"] span');

      // Valida que solo se le aplique a productos con tallas: 
      if(!/jibbitz/i.test(jbtz_url)) {
        // console.log('Tiene JBTZ');
        if(addToCartBtn > inputTalla.length > 0){
          addToCartBtn.disabled = true; // Deshabilite el botón
          addToCartBtnText.textContent = 'Selecciona una talla';
        }

        for(let i=0; i < inputTalla.length; i++) {             
          inputTalla[i].addEventListener('click', () => {    
            addToCartBtn.disabled = false; //Habilitar el botón
            addToCartBtnText.textContent = 'Agregar al carrito';            
          });  
        }  
      } else {
        addToCartBtn.disabled = false;   
        addToCartBtnText.textContent = 'Agregar al carrito';  
      }
  
    })();

    (function limpiarClickEnTalla() {
        let inputTalla = document.getElementsByClassName('input-size-validator');        
        let arr = Array.from(inputTalla);

        arr.find((item) => { 
            if(item.checked){
                item.checked = false;
            }
        })
    })();

    // Función que despliega el modal de Métodos de pago. 
    (function abrirModalDeMetodosDePago() {
      let payment_methods_button = document.getElementById('payment-methods-button');
      let payment_methods_modal = document.getElementById('modal-payment-methods');
      let modal_content = document.querySelector('.modal-content');
      let payment_methods_modal_close = document.getElementById('modal-payment-methods-close-button');
          
     
      if(payment_methods_button){
        payment_methods_button.addEventListener('click', () => { 
          payment_methods_modal.classList.add('modal-open');    
          payment_methods_modal.style.display = 'flex';             
          payment_methods_modal.addEventListener('animationend', () => { 
            payment_methods_modal.classList.remove('modal-open');               
          });                      
        });
      }  

      if(modal_content) {
        modal_content.addEventListener('click', () => {    
        });

        payment_methods_modal_close.addEventListener('click', () => {
         
          payment_methods_modal.style.display = 'none';   

          // payment_methods_modal.classList.add('modal-close');    
                      
          // payment_methods_modal.addEventListener('animationend', () => { 
          //   payment_methods_modal.classList.remove('modal-close');    
          //   payment_methods_modal.style.display = 'none';           
          // }); 
        });

        payment_methods_modal.addEventListener('click', () => {
          payment_methods_modal.style.display = 'none';
        });
      } 
    })();

    // Función que obtiene el valor del producto y muestra el color cuando se hace hover sobre la variante.
    (function getInfoVariantFile() {    
      fetch('https://cdn.shopify.com/s/files/1/0660/0468/0937/files/variantColorDefinitiva.csv?v=1668781084')
        .then(response => {
          if (!response.ok) {
              throw new Error('Error al cargar el archivo: ' + response.status);
          }
          return response.text();
        })
        .then(data => {       
          getVariant(data);
        })
        .catch(error => {
            // console.error(error);       
        });
    })();

    function getVariant(data) {

      var allRows = data.split(/\r?\n|\r/);
      var parent = document.getElementById("familyParent").value;
      var listaColor = [];
      for (var singleRow = 0; singleRow < allRows.length; singleRow++) {
        var rowCells = allRows[singleRow].split(';');
        if(rowCells[0] != undefined && rowCells[0] != null && rowCells[0] != ""){
          if(rowCells[0].includes(parent)){
            if(!listaColor.includes(rowCells[1])){
              listaColor.push(rowCells[1])
              document.querySelectorAll('.variant-color').forEach(function(element) {
                if (element.getAttribute('data-color') === rowCells[1]) {
                    element.setAttribute('data-name-color', rowCells[2]);
                }
              });
            
              // console.log($("#titleVariant").attr("data-color"));
              var titleVariant = document.getElementById("titleVariant");
              if (titleVariant.getAttribute("data-color") === rowCells[1]) {
                  titleVariant.setAttribute("data-name-color", rowCells[2]);
                  titleVariant.querySelector("span").textContent = rowCells[2];
              }
            }
          }
        }
      }
    }

    document.querySelectorAll('.variant-color').forEach(function(element) {
      element.addEventListener('mouseover', function() {
          document.querySelector("#titleVariant span").textContent = this.getAttribute("data-name-color");
      });
    });
  
    
    document.querySelector('.container-variant-color')?.addEventListener('mouseleave', function() {
        document.querySelector("#titleVariant span").textContent = document.querySelector("#titleVariant").getAttribute("data-name-color");
    });
  

});


window.addEventListener('load', () => {

  function calculateDiscountPercentage(regular_price = '0', last_price = '0'){
    const discount = Math.round(((parseInt(regular_price) - parseInt(last_price)) * 100) / regular_price);
    return isNaN(discount) ? 0 : discount;
    // return Math.round(((parseInt(regular_price) - parseInt(last_price))*100)/regular_price);
  } 

  let content_sizes = document.getElementsByClassName('container-item-talla');   
  let regular_variant_price = document.querySelector(".product__info-container .price .price__container .price__sale .price-item.price-item--regular");
  let last_variant_price = document.querySelector(".product__info-container .price .price__container .price__sale .price-item.price-item--last");

  console.log(regular_variant_price);
  console.log(last_variant_price);
    
  if(regular_variant_price && last_variant_price){
    regular_variant_price = regular_variant_price.innerText.replace(/[\Q\.]/g, "");
    last_variant_price = last_variant_price.innerText.replace(/[\Q\.]/g, "");

    console.log(regular_variant_price);
    console.log(last_variant_price);

    let discount_percentage = calculateDiscountPercentage(regular_variant_price, last_variant_price);   

    console.log('Porcentaje de: ', discount_percentage);

    if(discount_percentage != 0 && !isNaN(discount_percentage)){
      document.querySelector('.discount_tag .discount-tag__text').innerText = discount_percentage + '%OFF';
    }else {
      document.querySelector('.discount_tag .discount-tag__text').innerText = '';
    }
    
    for(let i=0; i<content_sizes.length;i++){      

      content_sizes[i].addEventListener('click', (e)=> {     
        let regular_variant_price = document.querySelector(".product__info-container .price .price__container .price__sale .price-item.price-item--regular").innerText.replace(/[\Q\.]/g, "");
        let last_variant_price = document.querySelector(".product__info-container .price .price__container .price__sale .price-item.price-item--last").innerText.replace(/[\Q\.]/g, "");
  
        let discount_percentage = calculateDiscountPercentage(regular_variant_price, last_variant_price);
        if(discount_percentage != 0){
          document.querySelector('.discount_tag .discount-tag__text').innerText = discount_percentage + '%OFF';
        }else {
          document.querySelector('.discount_tag .discount-tag__text').innerText = '';
        }
        
      });
    }  
  }


  // let we_detail_product_icon = document.querySelector('.wishlist-engine__detail-product-wrapper .wishlist-engine');
  // let we_button_add_icon = document.querySelector('.wishlist-engine__button-wrapper .wishlist-engine');

  // we_detail_product_icon.addEventListener('click', () => {
  //   we_button_add_icon.click();
  // });

  // we_button_add_icon.addEventListener('click', () => {
  //   we_detail_product_icon.click();
  // });

 




});




  




function reposicionarSliderProduct() {
  var product_description_mobile = document.querySelector('.product__description--mobile');
  var product_description_desktop = document.querySelector('.product__description--desktop');
  var slider  = document.querySelector('#slider-product');
  var screenWidth = window.innerWidth;

  console.log(screenWidth);
  if (screenWidth <= 749) {
    product_description_mobile?.insertBefore(slider, product_description_mobile.firstChild);
  } else {
    // product_description_desktop.insertBefore(slider, product_description_desktop.firstChild);

  }
}


window.addEventListener('load', function() {
  reposicionarSliderProduct();
});


// window.addEventListener('resize', function() {
//   reposicionarSliderProduct();
// });

